// extracted by mini-css-extract-plugin
export var fontWeightLight = "styles-__typography-module___fontWeightLight";
export var h7 = "styles-__typography-module___h7";
export var h8 = "styles-__typography-module___h8";
export var italic = "styles-__typography-module___italic";